import { Field } from 'module/api/field/types';
import { SelectFilterOperationType } from 'module/types/filter-field/filter/select';
import { SingleSelectFieldFilter } from 'module/types/filter-field/filter/single-select';
import type { FilterFunction } from 'module/ui/components/molecules/field-filter/types';
import { DEFAULT_FILTER_FUNCTION, getFieldValue } from './get-field-value';

export const single_select = (
  filter: SingleSelectFieldFilter,
): FilterFunction => {
  const value = getFieldValue<number>(filter.field as any as Field);

  switch (filter.type) {
    case SelectFilterOperationType.IsEmpty:
      return (record) => value(record) == null;
    case SelectFilterOperationType.IsNotEmpty:
      return (record) => value(record) != null;
    case SelectFilterOperationType.IsOneOf:
      return (record) => filter.value!.some((x) => x === value(record));
    case SelectFilterOperationType.IsNoneOf:
      return (record) => filter.value!.every((x) => x !== value(record));
    case SelectFilterOperationType.Is:
      return (record) => value(record) === filter.value;
    case SelectFilterOperationType.IsNot:
      return (record) => value(record) !== filter.value;
    case SelectFilterOperationType.IsAtLeast:
    case SelectFilterOperationType.IsAtMost: {
      // For single select, we are using position to compare the values.
      const { metaData } = filter.field;

      if (metaData == null) {
        return DEFAULT_FILTER_FUNCTION;
      }
      const { value: filterValue } = filter;
      const filterValuePosition = metaData.options.find(
        (o) => o.value === filterValue,
      )?.position;

      if (filterValuePosition == null) {
        return DEFAULT_FILTER_FUNCTION;
      }

      return (record) => {
        const recordValuePosition = metaData.options.find(
          (o) => o.value === value(record),
        )?.position;

        if (recordValuePosition == null) {
          return false;
        }

        return filter.type === SelectFilterOperationType.IsAtLeast
          ? recordValuePosition >= filterValuePosition
          : recordValuePosition <= filterValuePosition;
      };
    }
    default:
      return DEFAULT_FILTER_FUNCTION;
  }
};
